<template>
  <div class="container">
    <h2>{{ sect.field_2 }}</h2>
    <p v-if="sect.field_3" v-html="sect.field_3"></p>

    <transition-group name="articles" tag="div" class="row">
      <div
        v-for="(article, index) in pages.loaded"
        class="col-12 col-md-6 col-lg-4"
        v-bind:key="index + article.slug"
      >
        <a class="item news_item_link" :href="article.url">
          <div class="image bglazyload" :data-src="article.list_image_url"></div>
          <div class="copy">
            <div class="article-category">{{ article.category }}</div>
            <div class="article-title">{{ article.name }}</div>
          </div>
            <div v-if="article.formatted_news_date" class="article-category-date">{{ article.formatted_news_date }}</div>
          <div class="btn-square">
            <i class="icon icon-arrow"></i>
          </div>
        </a>
      </div>
    </transition-group>

    <button
      v-if="showButton"
      v-on:click="getPages"
      class="article-list-btn btn btn-white-blue btn-hover"
    >{{ load_more }}</button>
    <div class="article-list-loader">
      <img v-if="showLoader" src="/cdn/images/loaders/ball-clip-rotate-multiple.gif" class="loader" />
    </div>
  </div>
</template>
<script>
import ObserveForLazyLoad from "../../js/lazyload";
export default {
  props: {
    section: {
      section: Object,
      required: true
    },
    load_more: {
      section: String,
      default: "Load More"
    }
  },
  data() {
    return {
      page: 1,
      endpoint: "api/article-list/",
      pages: {
        loaded: [],
        preloaded: []
      },
      showLoader: false,
      showButton: false
    };
  },
  mounted() {
    this.getPages();

  },
  updated() {
       ObserveForLazyLoad.ObserveForLazyLoad();
  },
  methods: {

    async getPages() {
      try {
        this.showLoader = true;

        var pageTypeId = this.sect.field_4 || 2;
        var pageLength = this.sect.field_1;
        var apiUrl =
          this.endpoint + [pageTypeId, pageLength, this.page].join("/");
        var response = await axios.get(apiUrl);
        var data = response.data.data;

        function showHideButton(that) {
          if (data.length === 0) {
            that.showButton = false;
          } else {
            that.showButton = true;
          }
        }

        if (this.pages.loaded.length === 0) {
          this.pages.loaded = data;
          this.page++;
          this.getPages();
        } else if (this.pages.preloaded.length === 0) {
          this.pages.preloaded = data;
          showHideButton(this);
          this.page++;
        } else {
          this.pages.loaded = this.pages.loaded.concat(this.pages.preloaded);
          this.pages.preloaded = data;
          showHideButton(this);
          this.page++;
        }

        this.showLoader = false;
      } catch (err) {
        console.log(err);
      }
    }
  },
  computed: {
    sect: function() {
      return JSON.parse(this.section);
    }
  }
};
</script>
